import Vue from 'vue';
import store from './../../store';
import productFlowTransformer from './../../transformers/productFlow';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const productFlows = productFlowTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllproductFlows', productFlows);
  resolve(productFlows);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/productflow', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productFlow/all.js